import React, { useRef, useState, useLayoutEffect } from "react"
import { useViewportScroll, useTransform, useSpring, motion } from "framer-motion"
import { detect } from "detect-browser"

const isIeBrowser = /(ie)/i.test(detect().name)

export default function ParallaxItem({ children, className, maxAmount = 300 }) {
    const { scrollY } = useViewportScroll()
    /*  const springConfig = {
    duration: 0.1,
    bounce: 0,
  }*/
    //const y = useSpring(useTransform(scrollY, [0, 1000], [0, maxAmount]))
    let y = useTransform(scrollY, [0, 1000], [0, maxAmount])
    if (isIeBrowser) {
        y = 0
    }
    return (
        <motion.div className="motionDiv" initial={{ y: 0 }} style={{ y }}>
            {children}
        </motion.div>
    )
}
